import { mutate } from 'swr';
import { cache } from 'swr/_internal';

export const resetCache = () => mutate(() => true, undefined, { revalidate: true });

export const invalidate = (key: Record<string, string | number> | string | string[] | RegExp) => {
    mutate(
        (k) => {
            try {
                const keyString = typeof k === 'string' ? k : JSON.stringify(k);
                if (typeof key === 'string') {
                    return keyString.includes(key);
                }
                if (Array.isArray(key)) {
                    return key.some((needle) => keyString.includes(needle));
                }
                if (key instanceof RegExp) {
                    return key.test(keyString);
                }
                if (key && typeof key === 'object') {
                    return Object.entries(key).every(([valueKey, value]) => {
                        return (
                            keyString.includes(`${valueKey}:"${value}"`) || keyString.includes(`${valueKey}:${value}`)
                        );
                    });
                }
                return false;
            } catch {
                return false;
            }
        },
        undefined,
        { revalidate: true, populateCache: false, rollbackOnError: false, throwOnError: false }
    );

    // Backwards compatibility: ensure legacy per-key invalidation path still revalidates
    for (const cacheKey of cache.keys()) {
        if (typeof cacheKey !== 'string') continue;
        const keyString = cacheKey;
        let shouldInvalidate = false;
        if (typeof key === 'string') shouldInvalidate = keyString.includes(key);
        else if (Array.isArray(key)) shouldInvalidate = key.some((k) => keyString.includes(k));
        else if (key instanceof RegExp) shouldInvalidate = key.test(keyString);
        else if (key && typeof key === 'object') {
            shouldInvalidate = Object.entries(key).every(([valueKey, value]) => {
                return keyString.includes(`${valueKey}:"${value}"`) || keyString.includes(`${valueKey}:${value}`);
            });
        }
        if (shouldInvalidate)
            mutate(cacheKey, undefined, {
                revalidate: true,
                populateCache: false,
                rollbackOnError: false,
                throwOnError: false,
            });
    }
};
